import { render, staticRenderFns } from "./stampPdfOnly.vue?vue&type=template&id=7228a604&"
import script from "./stampPdfOnly.vue?vue&type=script&lang=js&"
export * from "./stampPdfOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports